import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import PackageCategoryService from "../../services/packagecategory.service";

/* =================== Thunks =================== */

export const getpackageCategory = createAsyncThunk(
  "packageCategory/getpackageCategory",
  async (params, thunkAPI) => {
    try {
      const response = await PackageCategoryService.getpackageCategory(params);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addpackageCategory = createAsyncThunk(
  "packageCategory/addpackageCategory",
  async (data, thunkAPI) => {
    try {
      const response = await PackageCategoryService.addpackageCategory(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const updatepackageCategory = createAsyncThunk(
  "packageCategory/updatepackageCategory",
  async (payload, thunkAPI) => {
    try {
      const response = await PackageCategoryService.editpackageCategory(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const deletepackageCategory = createAsyncThunk(
  "packageCategory/deletepackageCategory",
  async (id, thunkAPI) => {
    try {
      await PackageCategoryService.deletepackageCategory(id);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

/* =================== State =================== */

const initialState = {
  loading: false,
  error: null,
  packageCategoryList: [],
  updateSuccess: false,
};

/* =================== Slice =================== */

const packageCategorySlice = createSlice({
  name: "packageCategory",
  initialState,
  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder

      /* ---------- Get ---------- */
      .addCase(getpackageCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getpackageCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.packageCategoryList = action.payload?.packageCategory || [];
      })
      .addCase(getpackageCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Add ---------- */
      .addCase(addpackageCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addpackageCategory.fulfilled, (state, action) => {
        state.loading = false;
        const newHotel =
          action.payload?.data ||
          action.payload?.packageCategory ||
          action.payload;

        if (newHotel) {
          state.packageCategoryList.unshift(newHotel);
        }
      })
      .addCase(addpackageCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Update ---------- */
      .addCase(updatepackageCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.updateSuccess = false;
      })
      .addCase(updatepackageCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.updateSuccess = true;

        const updated =
          action.payload?.data || action.payload?.packageCategory;

        if (updated?._id) {
          const index = state.packageCategoryList.findIndex(
            (item) => item._id === updated._id
          );
          if (index !== -1) {
            state.packageCategoryList[index] = updated;
          }
        }
      })
      .addCase(updatepackageCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Delete ---------- */
      .addCase(deletepackageCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deletepackageCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.packageCategoryList = state.packageCategoryList.filter(
          (item) => item._id !== action.payload
        );
      })
      .addCase(deletepackageCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetUpdateStatus } = packageCategorySlice.actions;
export default packageCategorySlice.reducer;
